module.exports = __webpack_public_path__ + "img/outlander8.a09815b6.jpeg";